export const NOTIFICATION_BANNER_QUERY_KEY = "notification-banner"
